import { useRoutes } from '@/shared/routes';

export const accountsRoutes = [
  {
    path: useRoutes.ACCOUNT_LIST_PATH,
    name: useRoutes.ACCOUNT_LIST_NAME,
    component: () => import('@/pages/AccountList'),
  },
  {
    path: useRoutes.ACCOUNT_ITEM_PATH,
    name: useRoutes.ACCOUNT_ITEM_NAME,
    component: () => import('@/pages/RegisterAccount'),
  },
  {
    path: useRoutes.CHOISE_ACCOUNTS_PATH,
    name: useRoutes.CHOISE_ACCOUNTS_NAME,
    component: () => import('@/pages/ChoicePersonalAccounts'),
  },
  {
    path: useRoutes.CHOISE_PERSONAL_ACCOUNTS_PATH,
    name: useRoutes.CHOISE_PERSONAL_ACCOUNTS_NAME,
    component: () => import('@/pages/ChaptersPersonalAccounts'),
  },
];
